import * as React from "react";

export interface LegacyBadge {
    count: number;
    type: "error" | "info";
}

export function isLegacyBadge(badge: unknown): badge is LegacyBadge {
    return (
        typeof badge === "object" && badge !== null && "count" in badge && "type" in badge
    );
}

export interface SubnavPropsOwnProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    selectedSubpage: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    defaultSubpage: any;
    navigate: (subpage: string) => void;
    closeSection?: () => void;
    subpages: SubnavItem[];
    widthMode?: "screen" | "auto";
    headerComponent?: JSX.Element;
}

export interface SubnavItem {
    href?: string;
    subpage: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    children?: any;
    linkText: React.ReactNode;
    render: () => JSX.Element;
    badge?: LegacyBadge | React.ReactNode;
}
